import match from "conditional-expression";

import * as actionTypes from "./actionTypes";
import * as actions from "./actions";

const reducer = (state, { type, payload }) =>
  match(type)
    .equals(actionTypes.SET_USER)
    .then(() => actions.setUser(state)(payload.user))

    .equals(actionTypes.SET_AUTH_TOKEN)
    .then(() => actions.setToken(state)(payload.token))

    .equals(actionTypes.SET_PORTAL)
    .then(() => actions.setPortal(state)(payload.portal))

    .equals(actionTypes.SET_OPEN_USERS)
    .then(() => actions.setOpenUsers(state)(payload.openUsers))

    .equals(actionTypes.OPEN_USER)
    .then(() => actions.openUser(state)(payload.user))

    .equals(actionTypes.CLOSE_USER)
    .then(() => actions.closeUser(state)(payload.userId))

    .equals(actionTypes.SET_OPEN_LICENCES)
    .then(() => actions.setOpenLicences(state)(payload.openLicences))

    .equals(actionTypes.OPEN_LICENSE)
    .then(() => actions.openLicence(state)(payload.licence))

    .equals(actionTypes.SET_ROUTE_MESSAGE)
    .then(() => actions.setRouteMessage(state)(payload.route)(payload.message))

    .equals(actionTypes.DEL_ROUTE_MESSAGE)
    .then(() => actions.delRouteMessage(state)(payload.route))

    .else({ ...state });

export default reducer;
